import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { map, retry, switchMap } from 'rxjs/operators';
import { Subject, from, timer } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
import { EnvironmentLoaderService } from 'src/app/core/services/environment-loader.service';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  private httpClient = inject(HttpClient);
  private envLoaderService = inject(EnvironmentLoaderService);

  url: string = environment.fileUrl;
  fileSubject = new Subject<any[]>();

  public upload(data) {
    const uploadURL = this.url + 'intapgenric/file/uploadFileData';
    const requestOptions: any = {
      reportProgress: true,
      observe: 'events',
      'Content-Type': 'multipart/form-data',
    };

    const retryDelay$ = from(this.envLoaderService.getEnvData()).pipe(
      map((envData) => Number(envData?.FileUploadRetryDelay ?? 0)),
    );

    return retryDelay$.pipe(
      switchMap((retryDelay) => {
        const request$ = this.httpClient.post<any>(uploadURL, data, requestOptions).pipe(
          map((event) => {
            switch (event.type) {
              case HttpEventType.UploadProgress: {
                const progress = Math.round((100 * event.loaded) / event.total);
                return { status: 'progress', message: progress, progressTime: event.loaded, fileTotalSize: event.total };
              }
              case HttpEventType.Response:
                return event.body;
              default:
                return `Unhandled event: ${event.type}`;
            }
          }),
        );
        if (retryDelay === 0) {
          return request$;
        }
        return request$.pipe(
          retry({ count: 1, delay: (error) => {
            if (error?.status === 502) {
              return timer(retryDelay);
            }
            throw error;
          } }),
        );
      }),
    );
  }

  public deleteFile(fileID) {
    const uploadURL = this.url + 'deleteFileData?id=' + fileID;
    // return this.httpClient.delete(`${uploadURL}`, { responseType: 'text' });
    return this.httpClient.post(`${uploadURL}`, { responseType: 'text' });
  }

  setFileUploadEvent(file: any) {
    this.fileSubject.next(file);
  }

  get fileUploaded() {
    return this.fileSubject.asObservable();
  }

  public downloadFile(fileID) {
    return this.httpClient.get<any>(this.url + 'downloadFile?id=' + fileID);
  }

  public getFileData(ojectId, ojectType) {
    return this.httpClient.get<any>(this.url + 'getFileData/' + ojectId + '/' + ojectType);
  }
}
